var map = {
	"./1.jpg": "kk3T",
	"./2.jpg": "oYH7",
	"./3.jpg": "Mn6Z",
	"./4.jpg": "rOx1",
	"./5.jpg": "SAV3",
	"./6.jpg": "0Rvr",
	"./7.jpg": "8mm4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NTx0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/duplo2 ^\.\/.*\.jpg$
// module id = NTx0
// module chunks = 1